import { createSelector } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectPageType } from 'src/redux/navigation/selectors';
import { PageType } from 'src/types/navigation';
import { selectMatchedTaxonomyEntry } from './selectMatchedTaxonomyEntry';

export interface HeaderCopyBlockContent {
  description?: string;
  heading?: string;
  subheading?: string;
}

const selectContent = (state: ReduxApplicationState) => state.content;
const selectProductsPages = (state: ReduxApplicationState) => state.products.pages;

const toHeaderCopyBlockContent = (
  heading: string | undefined,
  subheading: string | undefined,
  introCopy: string | undefined,
  pages: ReduxApplicationState['products']['pages'],
): HeaderCopyBlockContent => {
  if (!heading) {
    return {};
  }

  return {
    heading,
    subheading,
    description: Object.keys(pages).includes('1') ? introCopy : undefined,
  };
};

export const selectHeaderCopyBlockContent = createSelector(
  [selectMatchedTaxonomyEntry, selectContent, selectProductsPages, selectPageType],
  (matchedEntry, content, pages, pageType): HeaderCopyBlockContent => {
    if (pageType === PageType.Shop) {
      const taxonomy = matchedEntry?.content;

      return toHeaderCopyBlockContent(
        taxonomy?.heading,
        taxonomy?.subheading,
        taxonomy?.introCopy,
        pages,
      );
    }

    if (pageType === PageType.Category) {
      return toHeaderCopyBlockContent(
        content.category?.heading,
        content.category?.subheading,
        content.category?.description,
        pages,
      );
    }

    return {};
  },
);
